import { RouterView } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'ceo-panel',
    component: RouterView,
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
    children: [
      {
        path: '',
        component: () => import('@/app/modules/ceo-panel/views/ceo-panel-index.vue'),
        redirect: '/ceo-panel/general-kpis',
        children: [
          {
            path: 'general-kpis',
            component: () => import('@/app/modules/ceo-panel/views/ceo-panel-general-kpis.vue'),
          },
          {
            path: 'sales-overview',
            component: () => import('@/app/modules/ceo-panel/views/ceo-panel-sales-overview.vue'),
          },
          {
            path: 'cash-cycle-analysis',
            component: () =>
              import('@/app/modules/ceo-panel/views/ceo-panel-cash-cycle-analysis.vue'),
          },
        ],
      },
    ],
  },
];
export default routes;
